import { isNearZero } from '../utils/functions.js';
import { Point } from './Shapes.js';

function intersectLine(start1, end1, start2, end2, isSegment) {
    const tangensdiff = ((end1.x - start1.x) * (end2.y - start2.y)) - ((end1.y - start1.y) * (end2.x - start2.x));
    if (isNearZero(tangensdiff)) {
        // parallel lines
        return;
    }
    const num1 = ((start1.y - start2.y) * (end2.x - start2.x)) - ((start1.x - start2.x) * (end2.y - start2.y));
    const num2 = ((start1.y - start2.y) * (end1.x - start1.x)) - ((start1.x - start2.x) * (end1.y - start1.y));
    const r = num1 / tangensdiff;
    const s = num2 / tangensdiff;
    if (isSegment && (r < 0 || r > 1 || s < 0 || s > 1)) {
        // r < 0 => line 1 is below line 2
        // r > 1 => line 1 is above line 2
        // s < 0 => line 2 is below line 1
        // s > 1 => line 2 is above line 1
        return;
    }
    return new Point(start1.x + (r * (end1.x - start1.x)), start1.y + (r * (end1.y - start1.y)));
}
const Intersect = {
    lines(start1, end1, start2, end2) {
        return intersectLine(start1, end1, start2, end2);
    },
    segments(start1, end1, start2, end2) {
        return intersectLine(start1, end1, start2, end2, true);
    },
    rectWithLine(rect, start, end) {
        return Intersect.segments(start, end, rect.topLeft(), rect.topRight()) ||
            Intersect.segments(start, end, rect.topRight(), rect.bottomRight()) ||
            Intersect.segments(start, end, rect.bottomLeft(), rect.bottomRight()) ||
            Intersect.segments(start, end, rect.topLeft(), rect.bottomLeft());
    },
    rects(rect1, rect2, angle) {
        let tl = rect2.topLeft(), tr = rect2.topRight(), bl = rect2.bottomLeft(), br = rect2.bottomRight();
        const center = rect2.center();
        if (angle) {
            tl = tl.rotate(angle, center);
            tr = tr.rotate(angle, center);
            bl = bl.rotate(angle, center);
            br = br.rotate(angle, center);
        }
        let intersect = rect1.contains(tl) ||
            rect1.contains(tr) ||
            rect1.contains(bl) ||
            rect1.contains(br) ||
            Intersect.rectWithLine(rect1, tl, tr) ||
            Intersect.rectWithLine(rect1, tl, bl) ||
            Intersect.rectWithLine(rect1, tr, br) ||
            Intersect.rectWithLine(rect1, bl, br);
        if (!intersect) { // last possible case is rect1 to be completely within rect2
            tl = rect1.topLeft();
            tr = rect1.topRight();
            bl = rect1.bottomLeft();
            br = rect1.bottomRight();
            if (angle) {
                const reverseAngle = 360 - angle;
                tl = tl.rotate(reverseAngle, center);
                tr = tr.rotate(reverseAngle, center);
                bl = bl.rotate(reverseAngle, center);
                br = br.rotate(reverseAngle, center);
            }
            intersect = rect2.contains(tl) ||
                rect2.contains(tr) ||
                rect2.contains(bl) ||
                rect2.contains(br);
        }
        return intersect;
    }
};

export { Intersect };
